var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"user-menu"},[(_vm.isDesktop)?_c('v-btn',{attrs:{"href":"https://app.motanamy.com","text":""}},[_vm._v(_vm._s(_vm.$t('header.login')))]):_vm._e(),_vm._v(" "),(_vm.isDesktop)?_c('v-spacer',{staticClass:"vertical-divider"}):_vm._e(),_vm._v(" "),_c('setting-menu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }